import { type JwtPayload, jwtDecode } from 'jwt-decode';

import {
    deleteCookies,
    getNewToken,
    redirectAfterLogout,
} from '../services/user-service';

const getCookie = (name: string): string | undefined => {
    const cookies = decodeURIComponent(document.cookie).split(';');
    const jwtCookie = cookies.find((cookie) => cookie.includes(`${name}=`));
    return jwtCookie?.split('=').pop();
};

const validateToken = async (token: string | undefined): Promise<void> => {
    const url = window.location.href;
    const allowedPaths = ['preferences', 'voorkeuren'];

    // Check if the URL contains any of the allowed paths
    const isAllowedPath = allowedPaths.some((path) => url.includes(path));

    //if the user is not authenticated and the path is preferences it shouldn't be redirected
    if (typeof token === 'undefined' && isAllowedPath) {
        return;
    }

    //if the user is not authenticated and the path is not preferences it should be redirected
    if (typeof token === 'undefined' && !isAllowedPath) {
        redirectAfterLogout();
        return;
    }

    try {
        const decoded = jwtDecode<JwtPayload>(token as string);
        // Current time in seconds
        const currentTime = Math.floor(Date.now() / 1000);
        if (decoded.exp && decoded.exp < currentTime) {
            // this should be replace with a refreshToken api
            const refreshToken = getCookie('refreshToken');
            let tokenRefreshStatus: number | null = null;
            let retries = 3;

            while (retries > 0) {
                try {
                    tokenRefreshStatus = await getNewToken(
                        refreshToken as string
                    );
                    break; // Success, exit retry loop
                } catch (error) {
                    retries--;
                    if (retries === 0) {
                        throw error; // All retries exhausted
                    }
                    console.warn(
                        `[user manager] token refresh failed, retrying... (${retries} attempts left)`,
                        error
                    );
                    // Wait before retrying (exponential backoff)
                    await new Promise((resolve) =>
                        setTimeout(resolve, Math.pow(2, 3 - retries) * 1000)
                    );
                }
            }

            if (tokenRefreshStatus !== 200) {
                console.log('[user manager] token expired, logging out');
                deleteCookies();
                return;
            }
        }
    } catch (error) {
        console.error('[user manager] invalid token, logging out', error);
        deleteCookies();
        return;
    }
};

export { getCookie, validateToken };
